// extracted by mini-css-extract-plugin
module.exports = {"btncontact":"ButtonContact_btncontact__34_Fs"};